require("!!/Users/leeray/Projects/promo/infositer/node_modules/script-loader/addScript.js")(require("!!/Users/leeray/Projects/promo/infositer/node_modules/raw-loader/index.js!/Users/leeray/Projects/promo/infositer/amp-premier/amp.premier/amp.premier.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./amp-premier/amp.premier/amp.premier.js
// module id = 862
// module chunks = 0